import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { interviewConsent } from './legalContent';

const InterviewConsent = () => {
  return <LegalPageLayout document={interviewConsent} />;
};

export default InterviewConsent;
